const methods = {
  // no-dd-sa:typescript-best-practices/no-explicit-any
  threeWaysArray: (arr: any) => {
    // no-dd-sa:typescript-best-practices/no-explicit-any
    const results: any[] = [];
    while (arr.length) {
      results.push(arr.splice(0, 3));
    }
    return results;
  }
}

// no-dd-sa:typescript-best-practices/no-explicit-any
export function useDataParsing(method: keyof typeof methods, arr: any[]) {
  const methodSelected = methods[method];
  return methodSelected(arr);
}
